__webpack_require__.p = "/Gowtham_Portfolio/";